"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAECarousel = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactMultiCarousel = _interopRequireDefault(require("react-multi-carousel"));

require("react-multi-carousel/lib/styles.css");

var _FAEContainer = require("../FAEContainer/FAEContainer");

var _FAELoading = require("../FAELoading/FAELoading");

require("./FAECarousel.scss");

const _excluded = ["children", "className", "justify", "align", "loading", "loaderProps", "slidesToShowOnDesktop", "slidesToShowOnMobile", "slidesToShowOnTablet"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAECarousel = _ref => {
  let {
    children,
    className = "",
    justify,
    align,
    loading,
    loaderProps,
    slidesToShowOnDesktop = 1,
    slidesToShowOnMobile = 1,
    slidesToShowOnTablet = 1
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const settings = _objectSpread({
    responsive: {
      desktop: {
        breakpoint: {
          max: 3000,
          min: 1000
        },
        items: slidesToShowOnDesktop
      },
      mobile: {
        breakpoint: {
          max: 500,
          min: 0
        },
        items: slidesToShowOnMobile
      },
      tablet: {
        breakpoint: {
          max: 1000,
          min: 500
        },
        items: slidesToShowOnTablet
      }
    },
    draggable: true
  }, rest);

  return /*#__PURE__*/_react.default.createElement(_FAEContainer.FAEContainer, {
    justify: justify,
    align: align
  }, loading ? /*#__PURE__*/_react.default.createElement(_FAELoading.FAELoading, loaderProps) : /*#__PURE__*/_react.default.createElement(_reactMultiCarousel.default, _extends({
    className: "slider-container ".concat(className)
  }, settings), children));
};

exports.FAECarousel = FAECarousel;